import { VerifiedUser as VerifiedUserIcon } from '@mui/icons-material';

const Verified = (): JSX.Element => <VerifiedUserIcon fontSize="inherit" />;

export default Verified;
